<template>
  <a
    v-on="$listeners"
    class="icon is-medium middle is-size-5"
    :data-tooltip="tooltip"
  >
    <i class="mdi" :class="[icon]"></i>
  </a>
</template>

<script>
export default {
  props: { icon: String, tooltip: String }
};
</script>
